// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1GXos","content":"ManualTimeModal_content__1YZzy"};